const initialState = {
  pdf: null, // media object
  isOpen: false
};

export const pdfViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_PDF_VIEWER": {
      return initialState;
    }
    case "SET_PDF_VIEWER": {
      return { ...state, ...action.pdfViewer };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/pdf-viewer.js